import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { granularityLevelSchema } from '../shared/schemes.js';

const ActivityPlatformsV2ResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        label: z.string(),
        name: z.string(),
      }),
    ),
  }),
});

export const getActivityPlatformsV2QueryOptions = defaultClient.query({
  url: 'data-ingestion/activity/$activityId/platforms/v2/' as const,
  method: 'GET',
  querySchema: z.object({
    granularityLevel: granularityLevelSchema,
  }),
  responseSchema: ActivityPlatformsV2ResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
  keyPrefix: ['activityPlatformsV2'],
});
